import { ChangeDetectorRef, inject, type OnDestroy, Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { type Subscription } from 'rxjs';

@Pipe({
  name: 'overrideDisplayName',
  pure: false
})
export class OverrideDisplayNamePipe implements PipeTransform, OnDestroy {
  private lang: string;
  private subscription: Subscription;

  private translate = inject(TranslateService);

  constructor(private cdr: ChangeDetectorRef) {
    this.lang = this.translate.currentLang;
    this.subscription = this.translate.onLangChange.subscribe(e => {
      this.lang = e.lang;
      this.cdr.markForCheck();
    });
  }

  transform(item: { displayNames?: Record<string, string>; name?: string } | null | undefined): string {
    if (!item) {
      return '';
    }
    const displayName = item.displayNames?.[this.lang]?.trim();
    const fallback = typeof item.name === 'string' && item.name.trim() !== '' ? this.translate.instant(item.name) : '';

    return displayName || fallback;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
